<aside class="pwa-snackbar-container">
  <p [innerHTML]="data.message" class="pwa-snackbar-container__message"></p>
  <div class="pwa-snackbar-container__actions">
    @if (data.actions.cancel) {
      <button
        mat-button
        class="pwa-snackbar-container__btn pwa-snackbar-container__btn-cancel"
        (click)="onCancel()"
        >
        Cancel
      </button>
    }
    @if (data.actions.confirm) {
      <button
        mat-flat-button
        class="pwa-snackbar-container__btn pwa-snackbar-container__btn-confirm"
        (click)="onConfirm()"
        >
        Confirm
      </button>
    }
  </div>
</aside>
